<template>
<v-container fluid :class="{'px-0':$vuetify.breakpoint.smAndDown}">
    <v-card max-width="1200" style="margin: 0 auto">
        <v-stepper v-model="el">
            <v-stepper-header>
                <v-stepper-step step="1">Detalii hotel</v-stepper-step>
                <v-divider />
                <v-stepper-step step="2">Date financiare</v-stepper-step>
                <v-divider />
                <v-stepper-step step="3">Utilizator</v-stepper-step>
                <v-divider />
                <v-stepper-step step="4">Sumar</v-stepper-step>
                <v-divider />
                <v-stepper-step step="5">Finalizare</v-stepper-step>
                <v-divider />
            </v-stepper-header>

            <v-stepper-items>
                <v-stepper-content step="1" :class="{'px-3':$vuetify.breakpoint.smAndDown}">
                    <im-hotel-data :hotel="hotel" @next="el = 2,writeOrgAddresAndContact()" />
                </v-stepper-content>

                <v-stepper-content step="2" :class="{'px-3':$vuetify.breakpoint.smAndDown}">
                    <im-organization :organization="organization" :billing="billing" @next="el = 3" @prev="el = 1" />
                </v-stepper-content>

                <v-stepper-content step="3" :class="{'px-3':$vuetify.breakpoint.smAndDown}">
                    <im-user :user="user" ref="user" :error_email="error_email" @next="el = 4" @prev="el = 2" @refreshEmail="error_email=false" />
                </v-stepper-content>

                <v-stepper-content step="4" :class="{'px-3':$vuetify.breakpoint.smAndDown}">
                    <im-summary :organization="organization" :billing="billing" :hotel="hotel" :user="user" :password="wrong_password" @editHotel="el = 1" @editOrganization="el = 2" @editUser="el = 3" />
                    <div class="py-3 d-flex justify-space-between">
                        <v-btn outlined :small="$vuetify.breakpoint.smAndDown" color="primary" @click="el = 3">
                            <v-icon size="16" color="primary">arrow_back_ios</v-icon>
                            <span v-if="$vuetify.breakpoint.smAndUp">Pasul anterior</span>
                            <span v-else>Inapoi</span>
                        </v-btn>
                        <div class="">
                            <v-btn class="mx-1" :small="$vuetify.breakpoint.smAndDown" color="primary" v-if="wrong_password" @click="resetPassword()">Resetare</v-btn>
                            <v-btn class="mx-1" :small="$vuetify.breakpoint.smAndDown" color="primary" v-if="!wrong_password" :loading="loading" @click="submit()">Salveaza</v-btn>
                            <v-btn class="mx-1" :small="$vuetify.breakpoint.smAndDown" color="primary" v-else :loading="loading" @click="tryAgainLogin()">Continuati</v-btn>
                        </div>
                    </div>
                </v-stepper-content>

                <v-stepper-content step="5" :class="{'px-3':$vuetify.breakpoint.smAndDown}">
                    <v-card class="ma-3">
                        <v-card-text>Hotelul dumneavoastra a fost inregistrat cu succes!</v-card-text>
                    </v-card>
                    <v-btn text @click="el = 4">Inapoi</v-btn>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
    </v-card>
</v-container>
</template>

<script>
import {
    mapActions
} from 'vuex';
import storage from '../../storage';
import logger from '../../logger.js';
import defaults from "../../components/utils/PropDefaults.js";

import HotelData from "./components/HotelData.vue"
import User from "./components/User.vue"
import Summary from "./components/Summary.vue"
import Organization from "./components/Organization.vue"
// calls for register
import HotelService from "./service/hotel.service.js"
import OrganizationService from "./service/organization.service.js"
import ProfileService from "./service/profile.service.js"
import SesionService from "./service/session.service.js"


export default {
    name: 'HotelRegistration',
    components: {
        "im-hotel-data": HotelData,
        "im-user": User,
        "im-organization": Organization,
        "im-summary": Summary,
    },
    data() {
        return {
            el: 1,
            wrong_password: false,
            loading: false,
            billing_address: false,
            google_address: null,
            policy_children: this.updatePolicyChildren(defaults.hotel_item.static.policy.children),
            user: {
                first_name: null,
                last_name: null,
                email: null,
                password: null,
                password_confirmation: null,
                gdpr: false,
                terms: false,
                'g-recaptcha-response': null,
            },
            organization: {
                address: {
                    country: 'RO',
                    street: null,
                    city: null,
                    region: null,
                    number: null,
                    building: null,
                    postal_code: null,
                },
                type: 'operator',
                email: '',
                name: '',
                phone: '',
                timezone: '',
            },
            billing: {
                address: {
                    country: "RO",
                    street: null,
                    city: null,
                    region: null,
                    number: null,
                    building: null,
                    postal_code: null,
                },
                name: null,
                fiscal_code: null,
                registry_number: null,
                type: 'legal',
                banks: [{
                    name: null,
                    account: null,
                    currency: null
                }]
            },
            hotel: this.$clone(defaults.hotel_item),
            response: {
                user: {},
                organization: {},
                billing: {},
                hotel: {},
                policy_refundable: {},
                policy_nonrefundable: {},
                rate_plan: {},
                room_single: {},
                room_double: {},
            },
            completed: {
                user: false,
                user_role: false,
                user_assign_org: false,
                organization: false,
                billing: false,
                hotel: false,
                policy_refundable: false,
                policy_nonrefundable: false,
                rate_plan: false,
                room_single: false,
                room_double: false,
            },
            error_registration: false,
            error_email: false,

        }
    },

    created() {

    },

    methods: {
        ...mapActions('alert', ['success', 'error']),

        submit() {
            this.loading = true;
            this.registerHotel();
        },

        async registerHotel() {
            let user_log_in = {
                email: this.user.email,
                password: this.user.password
            }
            try {
                await ProfileService.createUser(this.user);
                await SesionService.createSession(user_log_in);
                this.response.user = await ProfileService.getUserMe();
                // assing role for ssr console
                await ProfileService.assignRole(this.response.user.id, 1);
                // assing role for profiles owner
                await ProfileService.assignRole(this.response.user.id, 22);
                // create oraganization and billing
                this.response.organization = await OrganizationService.createOrganization(this.organization);
                // refresh session for adding roles
                await SesionService.destroySession(user_log_in);
                await SesionService.createSession(user_log_in);
                // prepare model for billing
                let bill_model = this.prepareBillModel();
                await OrganizationService.createBilling(bill_model);
                await this.createHotel();
                this.$router.push('/')
            } catch (e) {
                let message = e.toString();
                let status = JSON.stringify(this.completed);
                let trace = e.stack ? e.stack : 'N/A';
                logger.error(`component: RegisterHotel  , message: ${message}, status: ${status}`, trace)
                    .then(() => null)
                if(e.code == 422) {
                    this.login(user_log_in)
                } else {
                    this.forceLogin();
                }
                this.loading = false;

            }

        },

        async forceLogin() {
            let user_log_in = {
                email: this.user.email,
                password: this.user.password
            }
            await SesionService.destroySession(user_log_in);
            await SesionService.createSession(user_log_in);
            this.$router.push('/');
        },

        async login(user) {

            try {
                await SesionService.createSession(user);
                this.response.user = await ProfileService.getUserMe();
                // good password and continue registration
                // check and add roles
                this.checkUserRoles()
                // check if user has org_id
                await this.checkUserOrganization();
                await this.createHotel();
                this.loading = false;
                this.$router.push('/')
            } catch (e) {
                //bad password, show message
                this.wrong_password = true;
                this.loading = false;
            }
        },

        async tryAgainLogin() {
            this.loading = true;
            this.wrong_password = false;
            let user_log_in = {
                email: this.user.email,
                password: this.user.password
            }
            try {
                await SesionService.createSession(user_log_in);
                this.response.user = await ProfileService.getUserMe();
                // good password and continue registration
                // check and add roles
                this.checkUserRoles()
                // check if user has org_id
                await this.checkUserOrganization();
                await this.createHotel();
                this.$router.push('/')
            } catch (e) {
                //bad password, show message
                this.wrong_password = true;
                this.loading = false;
                this.$router.push('/')
            }
        },

        resetPassword() {
            let url = `https://${process.env.VUE_APP_RETURN_URL}/authentication/reset-password`;
            window.open(url, '_blank')
                .focus();
        },

        async checkUserRoles() {
            let user_log_in = {
                email: this.user.email,
                password: this.user.password
            }
            let roles = await storage.getRoles();
            let refresh_session = false;
            //user ssr_console role
            if(!roles.ssr_console.includes('user')) {
                await ProfileService.assignRole(this.response.user.id, 1);
                refresh_session = true;
            }
            if(!roles.services_profiles.includes('owner')) {
                await ProfileService.assignRole(this.response.user.id, 22);
                refresh_session = true;
            }
            if(refresh_session) {
                await SesionService.destroySession(user_log_in);
                await SesionService.createSession(user_log_in);
            }
        },

        async checkUserOrganization() {
            if(!this.response.user.organization_id) {
                this.response.organization = await OrganizationService.createOrganization(this.organization);
                let bill_model = this.prepareBillModel();
                await OrganizationService.createBilling(bill_model);
            }
        },

        async createHotel() {
            let slug = null;
            let i = 0;
            let hotel_model = this.prepareHotelModel();
            while(!slug) {
                slug = await HotelService.checkSlug(i, this.hotel.slug)
                i++;
            }
            hotel_model.slug = slug;

            this.response.hotel = await HotelService.createHotel(hotel_model);
            let policy_refundable_model = this.prepareCancellationPoliciesRefundable();
            let policy_nonrefundable_model = this.prepareCancellationPoliciesNonRefundable();
            this.response.policy_nonrefundable = await HotelService.createPolicy(policy_nonrefundable_model);
            let rate_plan_model = this.prepareRatePlan();
            this.response.policy_refundable = await HotelService.createPolicy(policy_refundable_model);
            this.response.rate_plan = await HotelService.createRatePlan(rate_plan_model);
            let room_single_model = this.prepareRoomSingle();
            let room_double_model = this.prepareRoomDouble();
            await HotelService.createRoom(room_single_model);
            await HotelService.createRoom(room_double_model);
        },

        writeOrgAddresAndContact() {
            this.organization.address.street = this.hotel.static.geo.address;
            this.organization.address.city = this.hotel.static.geo.city;
            this.organization.address.region = this.hotel.static.geo.region;
            this.organization.address.number = this.hotel.address.number;
            this.organization.address.postal_code = this.hotel.static.geo.postcode;
            this.organization.email = this.hotel.email;
            this.organization.phone = this.hotel.static.defaults.phone;
        },

        updatePolicyChildren(value) {
            let policy_children = this.$clone(value);
            if(value.allowed == false) {
                policy_children.allowed = "0";
            }
            if(value.allowed == true) {
                policy_children.allowed = "1";
            }
            if(value.infants.allowed == false) {
                policy_children.infants.allowed = "0";
            }
            if(value.infants.allowed == true) {
                policy_children.infants.allowed = "1";
            }
            if(value.small_children.allowed == false) {
                policy_children.small_children.allowed = "0";
            }
            if(value.small_children.allowed == true) {
                policy_children.small_children.allowed = "1";
            }
            if(value.big_children.allowed == false) {
                policy_children.big_children.allowed = "0";
            }
            if(value.big_children.allowed == true) {
                policy_children.big_children.allowed = "1";
            }
            return policy_children
        },

        prepareBillModel() {
            let organization = this.response.organization;
            let bill = this.$clone(this.billing);
            bill.name = organization.name;
            bill.email = organization.email;

            if(!this.billing.banks[0].name || !this.billing.banks[0].account || !this.billing.banks[0].account) {
                delete bill.banks
            }

            if(!bill.address.city && !bill.address.country && !bill.address.street && !bill.address.number && !bill.address.region && !bill.address.postal_code) {
                bill.address = this.$clone(this.organization.address);
            }

            Object.keys(bill)
                .forEach(function (key) {
                    if(bill[key] === undefined || bill[key] == "" || bill[key] === null) {
                        delete bill[key];
                    }
                    if(key == "contact" || key == "address") {
                        let obj_aux = bill[key];
                        Object.keys(obj_aux)
                            .forEach(function (key_aux) {
                                if(obj_aux[key_aux] === undefined || obj_aux[key_aux] == "" || obj_aux[key_aux] === null) {
                                    delete bill[key][key_aux];
                                }
                            });
                    }
                });



            return {
                resource_id: organization.id,
                resource_type: "organization",
                data: bill
            }
        },

        prepareHotelModel() {
            let item = this.$clone(this.hotel);
            if(this.hotel.address.number) {
                item.static.geo.address = this.hotel.static.geo.address + " nr." + this.hotel.address.number;
            }
            if(this.hotel.address.building) {
                item.static.geo.address = this.hotel.static.geo.address + " " + this.hotel.address.building;
            }

            delete item.address;
            delete item.financial;
            delete item.created_at;
            delete item.deleted_at;
            delete item.old_id;
            item.org_id = this.response.organization.id;
            item.static.policy.children = this.$clone(this.policy_children);
            item.static.contact.person = this.user.first_name + " " + this.user.last_name;
            item.static.contact.email = this.user.email;
            return item
        },

        prepareCancellationPoliciesRefundable() {
            let policy = this.$clone(defaults.cancellation_policy_item);
            policy.hotel_id = this.response.hotel.id;
            policy.refundable = true;
            policy.name = "Complet rambursabila";

            return policy
        },

        prepareCancellationPoliciesNonRefundable() {
            let policy = this.$clone(defaults.cancellation_policy_item);
            policy.hotel_id = this.response.hotel.id;
            policy.refundable = false;
            policy.name = "Nerambursabila";

            return policy
        },

        prepareRatePlan() {
            let rate_plan = this.$clone(defaults.rate_plan_item);
            rate_plan.hotel_id = this.response.hotel.id;
            rate_plan.cancellation_policy_id = this.response.policy_nonrefundable.id;
            rate_plan.stop_sell = false;
            rate_plan.name = "Standard";

            return rate_plan
        },

        prepareRoomSingle() {
            let room = this.$clone(defaults.room_type_item);
            room.rate_plans = [this.response.rate_plan.id];
            room.hotel_id = this.response.hotel.id;
            room.close_out = false;
            room.standard = "single";
            room.slug = "single";
            room.config.occupancy = 1;
            room.name = "Camera Single";
            room.description = "Camera are 1 pat de cel puțin 90 cm lățime pentru o persoană";

            return room
        },

        prepareRoomDouble() {
            let room = this.$clone(defaults.room_type_item);
            room.rate_plans = [this.response.rate_plan.id];
            room.hotel_id = this.response.hotel.id;
            room.close_out = false;
            room.standard = "double";
            room.slug = "double";
            room.config.occupancy = 2;
            room.name = "Camera Dubla";
            room.description = "Camera are 1 pat de cel puțin 160 cm lățime pentru două persoane";

            return room
        },

    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus"></style>
